import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useNavigate,
} from "react-router-dom";

import Banners from "../pages/Banners";
import Brands from "../pages/Brands";
import Catalog from "../pages/Catalog";
import DeliveryRegions from "../pages/DeliveryRegions";
import Integrations from "../pages/Integrations";
import Localization from "../pages/Localization";
import Login from "../pages/Login";
import OpeningHours from "../pages/OpeningHours";
import Orders from "../pages/Orders";
import PaymentOnDelivery from "../pages/PaymentOnDelivery";
import Settings from "../pages/Settings";
import Units from "../pages/Units";
import Users from "../pages/Users";
import Layout from "../shared/layouts/Layout";

import dayjs from "dayjs";
import { useEffect, useState } from "react";
import Avaliacoes from "../pages/Avaliacoes";
import Beneficios from "../pages/Beneficios";
import BeneficiosArquivados from "../pages/BeneficiosArquivados";
import BenefitDetails from "../pages/BenefitDetails";
import BenefitFolder from "../pages/BenefitFolder";
import Cashback from "../pages/Cashback";
import Cdp from "../pages/Cdp";
import Database from "../pages/Database";
import Fluxos from "../pages/Fluxos";
import Archived from "../pages/Fluxos/Archived";
import FlowDetails from "../pages/Fluxos/FlowDetails";
import FlowFolder from "../pages/Fluxos/FlowFolder";
import Message from "../pages/Message";
import Scheduling from "../pages/Scheduling";
import SecretSettings from "../pages/Settings/SecretSettings";
import SystemSettings from "../pages/Settings/SystemSettings";
import SecuritySettings from "../pages/Settings/SecuritySettings";
import Tables from "../pages/Tables";
import { OAuthAPI } from "../providers/OAuthAPI";
import { Empty } from "../shared/components/Empty";
import { Loading } from "../shared/components/Loading";
import { Icon } from "../shared/components/core/Icon";
import { Environment } from "../shared/core/Environment";
import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";
import { UserStorage } from "../shared/tools/UserStorage";
import ScrollToTop from "../shared/utils/ScrollToTop";

import useEventListener from "@hooks/useEventListener";
import ArchivedAudiences from "pages/ArchivedAudiences";
import ChildrenBenefits from "pages/ChildrenBenefits";
import DatabaseManagement from "pages/DatabaseManagement/DatabaseManagement";
import DatabaseManagementCity from "pages/DatabaseManagement/DatabaseManagementCity";
import DatabaseManagementProducts from "pages/DatabaseManagement/DatabaseManagementProducts";
import DatabaseManagementRegion from "pages/DatabaseManagement/DatabaseManagementRegion";
import DatabaseManagementSource from "pages/DatabaseManagement/DatabaseManagementSource";
import DatabaseManagementState from "pages/DatabaseManagement/DatabaseManagementState";
import CityFolder from "pages/DatabaseManagement/folders/CityFolder";
import RegionFolder from "pages/DatabaseManagement/folders/RegionFolder";
import SourceFolder from "pages/DatabaseManagement/folders/SourceFolder";
import StateFolder from "pages/DatabaseManagement/folders/StateFolder";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import ROLES from "../data/Roles";
import Marketing from "../pages/Marketing";
import Sales from "../pages/Sales";
import CustomersReports from "pages/Reports/Customers";
import IdentifiedCustomers from "pages/Reports/Customers/Identification";
import Campaign from "pages/Reports/Campaign";
import Coupon from "pages/Reports/Coupon";
import Creative from "pages/Reports/Creative";
import Campaigns from "pages/Reports/Marketing/Campaigns";
import Coupons from "pages/Reports/Marketing/Coupons";
import LifeCycle from "pages/Reports/Customers/LifeCycle";
import NewRegisters from "pages/Reports/Customers/NewRegisters";
import RFVProfiles from "pages/Reports/Customers/RFV";
import OrderReport from "pages/Reports/Orders";
import MarketingReports from "pages/Reports/Marketing";
import LoyaltyReports from "pages/Reports/Loyalty";
import LoyaltyIndicators from "pages/Reports/Loyalty/LoyaltyIndicators";
import LoyaltyOperations from "pages/Reports/Loyalty/LoyaltyOperations";
import LoyaltyEngagement from "pages/Reports/Loyalty/LoyaltyEngagement";
import LoyaltyCoupons from "pages/Reports/Loyalty/LoyaltyCoupons";

import CustomersCdp from "data/CustomersCdp";
import { AccessStorage } from "storage/AccessStorage";
import HomeConfigurations from "pages/HomeConfigurations";
import Bling from "pages/Bling";
import CampaignsDetails from "pages/Reports/Campaign/CampaignsDetails";
import Onboarding from "pages/Onboarding/Onboarding";
import OnboardingBrands from "pages/Onboarding/OnboardingBrands";
import OnboardingUnits from "pages/Onboarding/OnboardingUnits";
import OnboardingMapping from "pages/Onboarding/OnboardingMapping";
import ChangeMultipleProducts from "pages/ChangeMultipleProducts";
import { useIsMobile } from "shared/hooks/useIsMobile";
import Analytics from "pages/Analytics";
import Analytics2 from "pages/Analytics2";
import CreateFlows from "shared/containers/flows/CreateFlows";
import Service from "shared/containers/service/Service";

const AuthMiddleware = ({ children }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const accessToken = UserStorage.getAccessToken();

  const checkIsAValidToken = async () => {
    const response = await EnvironmentsAPI.getTokenIsValid();
    return response.getData({})?.is_valid;
  };

  useEffect(() => {
    const redirectToLogin = () => {
      if (UserStorage.isLogged()) {
        const environmentToken = Environment.token;
        const middlePortion = environmentToken?.split(".")[1];

        if (middlePortion) {
          const jwtBody = JSON.parse(
            Buffer.from(middlePortion, "base64").toString()
          );

          const daysToExpire = dayjs(jwtBody.exp * 1000).diff(dayjs(), "days");

          if (daysToExpire < 1) {
            UserStorage.setAccessToken(null);
            return navigate("/entrar", { replace: true });
          }
        }
      }
    };

    redirectToLogin();
  }, [navigate]);

  useEffect(() => {
    const checkToken = async () => {
      const isAValidToken = await checkIsAValidToken();

      if (!isAValidToken) localStorage.setItem("loggedOut", "true");

      if (!accessToken || !isAValidToken) {
        UserStorage.setAccessToken(null);
        return navigate("/entrar", { replace: true });
      }

      //Obter os dados do jwt
      const middlePortion = accessToken.split(".")[1];
      const jwtBody = JSON.parse(
        Buffer.from(middlePortion, "base64").toString()
      );

      const daysToExpire = dayjs(jwtBody.exp * 1000).diff(dayjs(), "days");
      //Se o token já expirou
      if (daysToExpire < 0) {
        UserStorage.setAccessToken(null);
        return navigate("/entrar", { replace: true });
      }

      // Se a expiração for menor de 4 dias de expirar (faltam 3 dias para expirar)
      if (daysToExpire < 4) {
        const response = await OAuthAPI.refresh();
        const { access_token: newAccessToken } = response.getData({
          accessToken: false,
        });

        //Se não foi possível renovar o token
        if (!newAccessToken) {
          UserStorage.setAccessToken(null);
          return navigate("/entrar", { replace: true });
        }

        UserStorage.setAccessToken(newAccessToken);
        UserStorage.setOcdpAccessToken(newAccessToken);
        AccessStorage.setXUserKey(newAccessToken);
        AccessStorage.setOlgaXUserKey(newAccessToken);
      }

      setIsLoading(false);
    };
    checkToken();
  }, []);

  useEffect(() => {
    // const { extra_menus } = EnvironmentStorage.getConfigurations() || {};
    // const { cashback, beneficios, avaliacoes } = extra_menus || {};

    // const olga_user = UserStorage.getOlgaLoggedUser();
    // const envId = olga_user?.environment_id;

    // const olgaActivated =
    //   cashback?.enabled ||
    //   beneficios?.enabled ||
    //   avaliacoes?.enabled;

    const installOlga = async () => {
      await Environment.install();
      await Environment.installConfigurations();
    };

    if (AccessStorage.getOcdpAccessToken() && !Environment.id) {
      installOlga();
    }
  }, []);

  //Se o usuário estiver autenticado
  if (!accessToken) {
    return <Navigate to="/entrar" replace />;
  }

  if (isLoading) {
    return <Loading fullContent />;
  }

  return children;
};

const withAuthMiddleware = (
  component,
  onlyUnit,
  onlyBrand,
  onlyGodMode,
  roles,
  allowUser = false
) => {
  const environment = EnvironmentStorage.getEnvironment();

  let allowed =
    (onlyBrand && environment?.type === "BRAND") ||
    (onlyUnit && environment?.type !== "BRAND") ||
    !(onlyBrand || onlyUnit) ||
    allowUser;

  allowed = allowed && (onlyGodMode ? UserStorage.isGodMode : allowed);

  let userRole = UserStorage.getLoggedUser()?.role;
  if (!userRole) userRole = ROLES.SHOPKEEPER;

  if (roles?.length > 0) {
    const allowRoute = roles.some((r) => r === userRole) || allowUser;

    if (!allowRoute)
      return (
        <AuthMiddleware>
          <Navigate to="/" />
        </AuthMiddleware>
      );
  }

  if (!allowed) {
    return (
      <AuthMiddleware>
        <Empty>
          <Icon name="store" size="4x" />
          <p>Ops!</p>
          <span>
            Essa página não está disponível para a{" "}
            {onlyUnit ? "marca" : "unidade"}, por favor, selecione uma{" "}
            {onlyUnit ? "unidade" : "marca"}, para acessá-la
          </span>
        </Empty>
      </AuthMiddleware>
    );
  }

  return <AuthMiddleware>{component}</AuthMiddleware>;
};

const AppRoutes = () => {
  const [userRole, setUserRole] = useState(null);
  const [username, setUsername] = useState(null);
  const [checkAllowCdp, setCheckAllowCdp] = useState(true);
  const [isOnboarding, setIsOnboarding] = useState(false);
  const [isOnboardingPages, setIsOnboardingPages] = useState(false);

  useEffect(() => {
    setUserRole(UserStorage.getLoggedUser()?.role || ROLES.MANAGER);
    setUsername(UserStorage.getLoggedUser()?.username);

    const olga_user = UserStorage.getOlgaLoggedUser();
    // const env = Environment.me;
    const envId = olga_user?.environment_id;

    setCheckAllowCdp(true);
  }, []);

  useEventListener("ON_LOGIN", () => {
    getIsOnboarding();

    setUserRole(UserStorage.getLoggedUser()?.role);
    setUsername(UserStorage.getLoggedUser()?.username);

    const olga_user = UserStorage.getOlgaLoggedUser();
    // const env = Environment.me;
    const envId = olga_user?.environment_id;

    setCheckAllowCdp(true);
  });

  const getIsOnboarding = async () => {
    const selectedEnvironment =
      await EnvironmentStorage.getEnvironmentHoldingId();
    const status = await EnvironmentsAPI.getConfigurationsByAlias(
      selectedEnvironment,
      "status"
    );
    localStorage.setItem("status-environment", status?.onboarding);
    setIsOnboarding(status?.onboarding === "PENDING");
  };

  useEffect(() => {
    const isOnboardingPages = [
      "/implantacao",
      "/implantacao/marcas",
      "/implantacao/unidades",
      "/implantacao/mapeamento",
    ].includes(window.location.pathname);

    setIsOnboardingPages(isOnboardingPages);
  }, [isOnboarding]);

  useEffect(() => {
    getIsOnboarding();
  }, []);

  const isMobile = useIsMobile();

  return (
    <Router>
      <ScrollToTop>
        <Layout>
          {isOnboarding && !isOnboardingPages && !UserStorage.isGodMode ? (
            <Navigate to="/implantacao" replace />
          ) : null}
          <Routes>
            <Route exact path="/entrar" element={<Login />} />
            <Route exact path="/login" element={<Login />} />
            <Route path="/implantacao">
              <Route
                index
                element={withAuthMiddleware(
                  <Onboarding />,
                  false,
                  false,
                  false,
                  [
                    ROLES.ADMIN,
                    ROLES.SUPPORT,
                    ROLES.MANAGER,
                    ROLES.MARKETING,
                    ROLES.SAC,
                  ]
                )}
              />
              <Route
                path="marcas"
                element={withAuthMiddleware(
                  <OnboardingBrands />,
                  false,
                  false,
                  false,
                  [
                    ROLES.ADMIN,
                    ROLES.SUPPORT,
                    ROLES.MANAGER,
                    ROLES.MARKETING,
                    ROLES.SAC,
                  ]
                )}
              />
              <Route
                path="unidades"
                element={withAuthMiddleware(
                  <OnboardingUnits />,
                  false,
                  false,
                  false,
                  [
                    ROLES.ADMIN,
                    ROLES.SUPPORT,
                    ROLES.MANAGER,
                    ROLES.MARKETING,
                    ROLES.SAC,
                  ]
                )}
              />
              <Route
                path="mapeamento"
                element={withAuthMiddleware(
                  <OnboardingMapping />,
                  false,
                  false,
                  false,
                  [
                    ROLES.ADMIN,
                    ROLES.SUPPORT,
                    ROLES.MANAGER,
                    ROLES.MARKETING,
                    ROLES.SAC,
                  ]
                )}
              />
              <Route
                path="fluxos"
                element={withAuthMiddleware(
                  <CreateFlows />,
                  false,
                  false,
                  false,
                  [
                    ROLES.ADMIN,
                    ROLES.SUPPORT,
                    ROLES.MANAGER,
                    ROLES.MARKETING,
                    ROLES.SAC,
                  ]
                )}
              />
            </Route>
            <Route
              path="/analytics"
              element={withAuthMiddleware(<Analytics />, false, false, false, [
                ROLES.SUPPORT,
              ])}
            />
            <Route
              path="/analytics2"
              element={withAuthMiddleware(<Analytics2 />, false, false, false, [
                ROLES.SUPPORT,
              ])}
            />
            <Route
              path="/"
              element={
                isMobile
                  ? null
                  : withAuthMiddleware(
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING].includes(
                        userRole
                      ) ? (
                        <Cdp />
                      ) : (
                        <Orders />
                      ),
                      userRole === ROLES.MANAGER ||
                        userRole === ROLES.SHOPKEEPER,
                      false,
                      false,
                      [
                        ROLES.SUPPORT,
                        ROLES.ADMIN,
                        ROLES.MARKETING,
                        ROLES.SAC,
                      ].includes(userRole)
                        ? [
                            ROLES.SUPPORT,
                            ROLES.ADMIN,
                            ROLES.MARKETING,
                            ROLES.SAC,
                          ]
                        : [ROLES.MANAGER, ROLES.SHOPKEEPER]
                    )
              }
            />
            <Route
              path="/fidelizacao-e-marketing"
              element={withAuthMiddleware(<Marketing />, false, false, false, [
                ROLES.ADMIN,
                ROLES.SUPPORT,
                ROLES.MARKETING,
                ROLES.SAC,
              ])}
            />
            <Route
              path="/vendas"
              element={withAuthMiddleware(<Sales />, false, false, false, [
                ROLES.ADMIN,
                ROLES.SUPPORT,
                ROLES.MARKETING,
              ])}
            />
            <Route
              path="pedidos"
              element={withAuthMiddleware(<Orders />, true, false, false, [
                ROLES.ADMIN,
                ROLES.SUPPORT,
                ROLES.MANAGER,
                ROLES.SHOPKEEPER,
                ROLES.SAC,
              ])}
            />
            <Route
              path="atendimento"
              element={withAuthMiddleware(<Service />, true, false, false, [
                ROLES.ADMIN,
                ROLES.SUPPORT,
                ROLES.MANAGER,
                ROLES.SHOPKEEPER,
                ROLES.SAC,
              ])}
            />
            <Route path="relatorios">
              <Route path="pedidos">
                <Route
                  index
                  element={withAuthMiddleware(
                    <OrderReport />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.MARKETING,
                      ROLES.SAC,
                    ]
                  )}
                />
              </Route>
              <Route path="marketing">
                <Route
                  index
                  element={withAuthMiddleware(
                    <MarketingReports />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.MARKETING,
                      ROLES.SAC,
                    ]
                  )}
                />

                <Route
                  path="campanhas"
                  element={withAuthMiddleware(
                    <Campaigns />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.MARKETING,
                      ROLES.SAC,
                    ]
                  )}
                />
                <Route
                  path="cupons"
                  element={withAuthMiddleware(
                    <Coupons />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.MARKETING,
                      ROLES.SAC,
                    ]
                  )}
                />
              </Route>

              <Route path="fidelizacao">
                <Route
                  index
                  element={withAuthMiddleware(
                    <LoyaltyReports />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.MARKETING,
                      ROLES.SAC,
                    ]
                  )}
                />

                <Route
                  path="indicadores"
                  element={withAuthMiddleware(
                    <LoyaltyOperations />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.MARKETING,
                      ROLES.SAC,
                    ]
                  )}
                />
                <Route
                  path="operacoes"
                  element={withAuthMiddleware(
                    <LoyaltyOperations />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.MARKETING,
                      ROLES.SAC,
                    ]
                  )}
                />
                <Route
                  path="engajamento"
                  element={withAuthMiddleware(
                    <LoyaltyEngagement />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.MARKETING,
                      ROLES.SAC,
                    ]
                  )}
                />
                <Route
                  path="indicadores-de-pontos"
                  element={withAuthMiddleware(
                    <LoyaltyCoupons />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.MARKETING,
                      ROLES.SAC,
                    ]
                  )}
                />
              </Route>
              <Route
                path="campanhas"
                element={withAuthMiddleware(
                  <CampaignsDetails />,
                  false,
                  false,
                  false,
                  [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                )}
              />
              <Route
                path="campanha/:id"
                element={withAuthMiddleware(<Campaign />, false, false, false, [
                  ROLES.SUPPORT,
                  ROLES.ADMIN,
                  ROLES.MARKETING,
                  ROLES.SAC,
                ])}
              />
              <Route
                path="cupom/:id"
                element={withAuthMiddleware(<Coupon />, false, false, false, [
                  ROLES.SUPPORT,
                  ROLES.ADMIN,
                  ROLES.MARKETING,
                  ROLES.SAC,
                ])}
              />
              <Route
                path="criativo/:id"
                element={withAuthMiddleware(<Creative />, false, false, false, [
                  ROLES.SUPPORT,
                  ROLES.ADMIN,
                  ROLES.MARKETING,
                  ROLES.SAC,
                ])}
              />
              <Route path="clientes">
                <Route
                  index
                  element={withAuthMiddleware(
                    <CustomersReports />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.MARKETING,
                      ROLES.SAC,
                    ]
                  )}
                />

                <Route
                  path="clientes-identificados"
                  element={withAuthMiddleware(
                    <IdentifiedCustomers />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.SHOPKEEPER,
                      ROLES.SAC,
                      ROLES.MARKETING,
                    ]
                  )}
                />
                <Route
                  path="perfis-rfv"
                  element={withAuthMiddleware(
                    <RFVProfiles />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.SHOPKEEPER,
                      ROLES.SAC,
                      ROLES.MARKETING,
                    ]
                  )}
                />
                <Route
                  path="ciclo-de-vida"
                  element={withAuthMiddleware(
                    <LifeCycle />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.SHOPKEEPER,
                      ROLES.SAC,
                      ROLES.MARKETING,
                    ]
                  )}
                />
                <Route
                  path="novos-cadastros"
                  element={withAuthMiddleware(
                    <NewRegisters />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.SHOPKEEPER,
                      ROLES.SAC,
                      ROLES.MARKETING,
                    ]
                  )}
                />
              </Route>
            </Route>
            <Route
              path="mensageria"
              element={withAuthMiddleware(<Message />, false, false, false, [
                ROLES.ADMIN,
                ROLES.SUPPORT,
                ROLES.MARKETING,
              ])}
            />
            <Route path="cdp">
              <Route
                index
                element={withAuthMiddleware(<Cdp />, false, false, false, [
                  ROLES.ADMIN,
                  ROLES.SUPPORT,
                  ROLES.MARKETING,
                  ROLES.SAC,
                ])}
              />
              <Route
                path="publicos-arquivados"
                element={withAuthMiddleware(
                  <ArchivedAudiences />,
                  false,
                  false,
                  false,
                  [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                )}
              />
              <Route path="tratamento-de-base">
                <Route
                  index
                  element={withAuthMiddleware(
                    <DatabaseManagement />,
                    false,
                    false,
                    false,
                    [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                  )}
                />
                <Route path="produtos">
                  <Route
                    index
                    element={withAuthMiddleware(
                      <DatabaseManagementProducts />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                  <Route
                    path=":id"
                    element={withAuthMiddleware(
                      <CityFolder />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                </Route>
                <Route path="origem">
                  <Route
                    index
                    element={withAuthMiddleware(
                      <DatabaseManagementSource />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                  <Route
                    path=":id"
                    element={withAuthMiddleware(
                      <SourceFolder />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                </Route>
                <Route path="bairro">
                  <Route
                    index
                    element={withAuthMiddleware(
                      <DatabaseManagementRegion />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                  <Route
                    path=":id"
                    element={withAuthMiddleware(
                      <RegionFolder />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                </Route>
                <Route path="cidade">
                  <Route
                    index
                    element={withAuthMiddleware(
                      <DatabaseManagementCity />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                  <Route
                    path=":id"
                    element={withAuthMiddleware(
                      <CityFolder />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                </Route>
                <Route path="estados">
                  <Route
                    index
                    element={withAuthMiddleware(
                      <DatabaseManagementState />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                  <Route
                    path=":id"
                    element={withAuthMiddleware(
                      <StateFolder />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                </Route>
              </Route>
            </Route>
            <Route path="cdp1">
              <Route index element={<Database />} />
            </Route>
            <Route path="base-de-dados">
              <Route
                index
                element={withAuthMiddleware(<Cdp />, false, false, false, [
                  ROLES.SUPPORT,
                  ROLES.ADMIN,
                  ROLES.MARKETING,
                  ROLES.SAC,
                ])}
              />
              <Route path="tratamento-de-base">
                <Route
                  index
                  element={withAuthMiddleware(
                    <DatabaseManagement />,
                    false,
                    false,
                    false,
                    [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                  )}
                />
                <Route path="produtos">
                  <Route
                    index
                    element={withAuthMiddleware(
                      <DatabaseManagementProducts />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                  <Route
                    path=":id"
                    element={withAuthMiddleware(
                      <CityFolder />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                </Route>
                <Route path="origem">
                  <Route
                    index
                    element={withAuthMiddleware(
                      <DatabaseManagementSource />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                  <Route
                    path=":id"
                    element={withAuthMiddleware(
                      <SourceFolder />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                </Route>
                <Route path="bairro">
                  <Route
                    index
                    element={withAuthMiddleware(
                      <DatabaseManagementRegion />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                  <Route
                    path=":id"
                    element={withAuthMiddleware(
                      <RegionFolder />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                </Route>
                <Route path="cidade">
                  <Route
                    index
                    element={withAuthMiddleware(
                      <DatabaseManagementCity />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                  <Route
                    path=":id"
                    element={withAuthMiddleware(
                      <CityFolder />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                </Route>
                <Route path="estados">
                  <Route
                    index
                    element={withAuthMiddleware(
                      <DatabaseManagementState />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                  <Route
                    path=":id"
                    element={withAuthMiddleware(
                      <StateFolder />,
                      false,
                      false,
                      false,
                      [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                    )}
                  />
                </Route>
              </Route>
              <Route
                path="publicos-arquivados"
                element={withAuthMiddleware(
                  <ArchivedAudiences />,
                  false,
                  false,
                  false,
                  [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                )}
              />
              <Route
                path=":id"
                element={withAuthMiddleware(
                  <FlowFolder />,
                  false,
                  false,
                  false,
                  [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                )}
              />
            </Route>
            <Route path="fluxos">
              <Route
                index
                element={withAuthMiddleware(<Fluxos />, false, false, false, [
                  ROLES.SUPPORT,
                  ROLES.ADMIN,
                  ROLES.MARKETING,
                  ROLES.SAC,
                ])}
              />
              <Route
                path="pasta/:id"
                element={withAuthMiddleware(
                  <FlowFolder />,
                  false,
                  false,
                  false,
                  [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                )}
              />
              <Route
                path="arquivados"
                element={withAuthMiddleware(<Archived />, false, false, false, [
                  ROLES.SUPPORT,
                  ROLES.ADMIN,
                  ROLES.MARKETING,
                  ROLES.SAC,
                ])}
              />
              <Route
                path="criacao"
                element={withAuthMiddleware(<CreateFlows />, false, false, false, [
                  ROLES.SUPPORT,
                  ROLES.ADMIN,
                  ROLES.MARKETING,
                  ROLES.SAC,
                ])}
              />
              <Route
                path=":id"
                element={withAuthMiddleware(
                  <FlowDetails />,
                  false,
                  false,
                  false,
                  [ROLES.SUPPORT, ROLES.ADMIN, ROLES.MARKETING, ROLES.SAC]
                )}
              />
            </Route>
            <Route
              path="cashback"
              element={withAuthMiddleware(<Cashback />, false, false, false, [
                ROLES.ADMIN,
                ROLES.SUPPORT,
                ROLES.MARKETING,
              ])}
            />
            <Route
              path="fidelidade"
              element={withAuthMiddleware(<Cashback />, false, false, false, [
                ROLES.ADMIN,
                ROLES.SUPPORT,
                ROLES.MARKETING,
              ])}
            />
            <Route
              path="avaliacoes"
              element={withAuthMiddleware(<Avaliacoes />, false, false, false, [
                ROLES.ADMIN,
                ROLES.SUPPORT,
                ROLES.MARKETING,
                ROLES.SAC,
              ])}
            />
            <Route path="beneficios">
              <Route
                index
                element={withAuthMiddleware(
                  <Beneficios />,
                  false,
                  false,
                  false,
                  [ROLES.ADMIN, ROLES.SUPPORT, ROLES.MARKETING, ROLES.SAC]
                )}
              />
              <Route
                path="detalhes/:id"
                element={withAuthMiddleware(
                  <BenefitDetails />,
                  false,
                  false,
                  false,
                  [ROLES.ADMIN, ROLES.SUPPORT, ROLES.MARKETING, ROLES.SAC]
                )}
              />

              <Route
                path="detalhes/:id/vinculos"
                element={withAuthMiddleware(
                  <ChildrenBenefits />,
                  false,
                  false,
                  false,
                  [ROLES.ADMIN, ROLES.SUPPORT, ROLES.MARKETING, ROLES.SAC]
                )}
              />

              <Route
                path="pasta/:id"
                element={withAuthMiddleware(
                  <BenefitFolder />,
                  false,
                  false,
                  false,
                  [ROLES.ADMIN, ROLES.SUPPORT, ROLES.MARKETING, ROLES.SAC]
                )}
              />
              <Route
                path="arquivados"
                element={withAuthMiddleware(
                  <BeneficiosArquivados />,
                  false,
                  false,
                  false,
                  [ROLES.ADMIN, ROLES.SUPPORT, ROLES.MARKETING, ROLES.SAC]
                )}
              />
            </Route>
            <Route path="configuracoes">
              <Route
                index
                element={withAuthMiddleware(<Settings />, false, false, false, [
                  ROLES.ADMIN,
                  ROLES.SUPPORT,
                  ROLES.MANAGER,
                  ROLES.SHOPKEEPER,
                  ROLES.SAC,
                  ROLES.MARKETING,
                ])}
              />
              <Route
                path="marcas"
                element={withAuthMiddleware(<Brands />, false, false, false, [
                  ROLES.ADMIN,
                  ROLES.SUPPORT,
                  ROLES.MANAGER,
                  ROLES.SHOPKEEPER,
                  ROLES.SAC,
                ])}
              />
              <Route
                path="unidade/:id"
                element={withAuthMiddleware(<Units />, false, false, false, [
                  ROLES.ADMIN,
                  ROLES.SUPPORT,
                  ROLES.MANAGER,
                  ROLES.SHOPKEEPER,
                  ROLES.SAC,
                ])}
              />
              <Route
                path="personalizacao-do-inicio"
                element={withAuthMiddleware(
                  <HomeConfigurations />,
                  false,
                  false,
                  false,
                  [
                    ROLES.SUPPORT,
                    ROLES.ADMIN,
                    ROLES.MARKETING,
                    ROLES.SAC,
                    ROLES.MANAGER,
                  ]
                )}
              />
              <Route path="cardapio">
                <Route
                  index
                  element={withAuthMiddleware(
                    <Catalog />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.SHOPKEEPER,
                      ROLES.SAC,
                    ]
                  )}
                />
                <Route
                  path="precos-e-skus"
                  element={withAuthMiddleware(
                    <ChangeMultipleProducts />,
                    false,
                    false,
                    false,
                    [
                      ROLES.ADMIN,
                      ROLES.SUPPORT,
                      ROLES.MANAGER,
                      ROLES.SHOPKEEPER,
                    ]
                  )}
                />
              </Route>
              <Route
                path="horarios-de-atendimento"
                element={withAuthMiddleware(
                  <OpeningHours />,
                  true,
                  false,
                  false,
                  [
                    ROLES.ADMIN,
                    ROLES.SUPPORT,
                    ROLES.MANAGER,
                    ROLES.SHOPKEEPER,
                    ROLES.SAC,
                  ]
                )}
              />
              <Route
                path="localizacao"
                element={withAuthMiddleware(
                  <Localization />,
                  true,
                  false,
                  false,
                  [
                    ROLES.ADMIN,
                    ROLES.SUPPORT,
                    ROLES.MANAGER,
                    ROLES.SHOPKEEPER,
                    ROLES.SAC,
                  ]
                )}
              />
              <Route
                path="banners"
                element={withAuthMiddleware(<Banners />, false, false, false, [
                  ROLES.ADMIN,
                  ROLES.SUPPORT,
                  ROLES.MANAGER,
                  ROLES.SHOPKEEPER,
                  ROLES.SAC,
                  ROLES.MARKETING,
                ])}
              />
              <Route
                path="agendamento"
                element={withAuthMiddleware(
                  <Scheduling />,
                  true,
                  false,
                  false,
                  [
                    ROLES.ADMIN,
                    ROLES.SUPPORT,
                    ROLES.MANAGER,
                    ROLES.SHOPKEEPER,
                    ROLES.SAC,
                  ]
                )}
              />
              <Route
                path="mesas"
                element={withAuthMiddleware(<Tables />, true, false, false, [
                  ROLES.ADMIN,
                  ROLES.SUPPORT,
                  ROLES.MANAGER,
                  ROLES.SHOPKEEPER,
                  ROLES.SAC,
                ])}
              />
              <Route
                path="regioes-de-entrega"
                element={withAuthMiddleware(
                  <DeliveryRegions />,
                  true,
                  false,
                  false,
                  [
                    ROLES.ADMIN,
                    ROLES.SUPPORT,
                    ROLES.MANAGER,
                    ROLES.SHOPKEEPER,
                    ROLES.SAC,
                  ]
                )}
              />
              <Route
                path="secretas"
                element={withAuthMiddleware(
                  <SecretSettings />,
                  false,
                  false,
                  false,
                  [ROLES.ADMIN, ROLES.SUPPORT, ROLES.MANAGER]
                )}
              />
              <Route
                path="sistema"
                element={withAuthMiddleware(
                  <SystemSettings />,
                  false,
                  false,
                  false,
                  [
                    ROLES.ADMIN,
                    ROLES.SUPPORT,
                    ROLES.MANAGER,
                    ROLES.SHOPKEEPER,
                    ROLES.SAC,
                  ]
                )}
              />
              <Route
                path="seguranca"
                element={withAuthMiddleware(
                  <SecuritySettings />,
                  false,
                  false,
                  false,
                  [
                    ROLES.ADMIN,
                    ROLES.SUPPORT,
                    ROLES.MANAGER,
                    ROLES.SHOPKEEPER,
                    ROLES.SAC,
                  ]
                )}
              />
              <Route
                path="pagamento-na-entrega"
                element={withAuthMiddleware(
                  <PaymentOnDelivery />,
                  true,
                  false,
                  false,
                  [
                    ROLES.ADMIN,
                    ROLES.SUPPORT,
                    ROLES.MANAGER,
                    ROLES.SHOPKEEPER,
                    ROLES.SAC,
                  ]
                )}
              />
            </Route>
            <Route path="integracoes">
              <Route
                index
                element={withAuthMiddleware(
                  <Integrations />,
                  false,
                  false,
                  false,
                  [ROLES.ADMIN, ROLES.SUPPORT, ROLES.MANAGER]
                )}
              />
              <Route
                path="bling"
                element={withAuthMiddleware(<Bling />, false, false, false, [
                  ROLES.ADMIN,
                  ROLES.SUPPORT,
                  ROLES.MANAGER,
                ])}
              />
            </Route>
            <Route
              path="usuarios"
              element={withAuthMiddleware(<Users />, false, false, false, [
                ROLES.ADMIN,
                ROLES.SUPPORT,
                ROLES.MANAGER,
                ROLES.SHOPKEEPER,
              ])}
            />
          </Routes>
        </Layout>
      </ScrollToTop>
    </Router>
  );
};

export default AppRoutes;
